import React, { BaseSyntheticEvent } from 'react';
import { ISubHeading } from '../../../common/cq-inputs';
import { CommonRuleModal } from '../layout-configuration-panel/apply-rule/common-rule-modal';
import { SelectRuleTypeDropDown } from '../layout-configuration-panel/apply-rule/select-rule-type.component';
import { ICoreRule, ICriteria } from '../layout-configuration-panel/ILayoutConfigurationPanel.Interface';

export interface IState extends ICoreRule {
    isVisible: string;
    isFormValid: boolean;
    ruleObject: object;
    ruleJSON: string;
    fieldType?: string;
    compareFieldType?: string;
    additionalFields?: any[];
    shouldRenderDelete ?:boolean
}

type GridModalType = 
    'headerAction' |
    'rowAction' |
    'customComponentAction';

interface IProps {
    onActionPerformed: (actionType: string, value?: IState) => void;
    modalInfo: {
        isFormValid: boolean;
        optionInfo: {
            options: any[];
            subHeading?: ISubHeading[]
        };
        gridType: GridModalType
        label: string;
    }
    modalState: {
        initialCriteria: ICriteria;
        state: IState;
    }
    templateName: string
    shouldRenderDelete?:boolean
    selectedCustomComponent?: any
    selectedIndex?: any
}

const GridModal = (props: IProps) => {
    const { 
        onActionPerformed,
        modalInfo: { isFormValid, optionInfo, label, gridType },
        modalState: { initialCriteria, state },
        templateName
    } = props;

    return (
        <>
            <section role="dialog" className="slds-modal slds-fade-in-open slds-modal_small">
                <div className="slds-modal__container">
                    <header className="slds-modal__header">
                        <h2 className="slds-text-heading_medium slds-hyphenate">
                            {label}
                        </h2>
                        { props.selectedCustomComponent &&
                            <div>
                                {props.selectedCustomComponent.fields[props.selectedIndex].label}
                                {props.selectedCustomComponent.fields[props.selectedIndex].displayField 
                                ? ` - ${props.selectedCustomComponent.fields[props.selectedIndex].referenceLabel}` 
                                : null}
                            </div>
                        }
                        <p></p>
                    </header>
                    <div className="slds-modal__content slds-p-around_medium" id="modal-content-id-1">
                        <>
                            <SelectRuleTypeDropDown 
                                fieldData= {{
                                    type: gridType,
                                    isComponentEventRule: false
                                }}
                                editOnly= {false}
                                onRuleTypeChanged= 
                                    {(e: BaseSyntheticEvent) => 
                                        onActionPerformed('updateState', {...state, isVisible: e.target.value})}
                                appliedRule= {state.isVisible}
                            />
                            <div className="slds-grid slds-grid_vertical">
                                {state.isVisible === 'true' &&
                                    <CommonRuleModal 
                                        templateName= {templateName}
                                        parentAction= {{
                                            updateExtraState: () => {},
                                            updateState: (state: IState) => { onActionPerformed('updateState', state) }
                                        }}
                                        parentInfo= {{
                                            state: state,
                                            extraState: undefined,
                                            initialCriteria: initialCriteria,
                                            addFieldOnSkip: false
                                        }}
                                        modalInfo= {{
                                            shouldDisableFirstElement: false,
                                            shouldRenderAddComplexBtn: true,
                                            toggleModalVisibility: () => { onActionPerformed('closeModal') },
                                            optionInfo,
                                            hideSkipBtn: true
                                        }}
                                    />
                                }
                                <div className="slds-grid marginTop15">
                                    <div className="slds-form-element full-width">
                                        <label className="slds-form-element__label">Applied Rule</label>
                                        <div className="slds-form-element__control">
                                            <textarea id=""
                                                readOnly={true}
                                                placeholder="Placeholder Text" 
                                                className="slds-textarea textarea-md" 
                                                value={!isFormValid ? state.ruleJSON : ''}></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    </div>
                    <footer className="slds-modal__footer">
                        <button 
                            className="slds-button slds-button_neutral" 
                            onClick={() => onActionPerformed('closeModal')}
                        >
                            Cancel
                        </button>
                        {
                            props.shouldRenderDelete
                                    ? <button 
                                        className="slds-button slds-button_brand"
                                        onClick={()=>onActionPerformed('onRuleDelete')}
                                        >
                                            Delete
                                        </button>
                                    : null
                        }
                        <button 
                            className="slds-button slds-button_brand" 
                            disabled={isFormValid} 
                            onClick={() => onActionPerformed('previewRule')}
                        >
                            Preview
                        </button>
                        <button 
                            className="slds-button slds-button_brand" 
                            disabled={isFormValid} 
                            onClick={() => onActionPerformed('saveRule')}
                        >
                            Save
                        </button>
                    </footer>
                </div>
            </section>
            <div className="slds-backdrop slds-backdrop_open"></div>
        </>
    );
}

export default GridModal;